var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162.7 162.7",
    style: {
      enableBackground: "new 0 0 162.7 162.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FAD9DA;stroke:#3C3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st2{fill:#FCE7E8;stroke:#3C3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#3C3C3C;stroke-width:2.8346;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:#3C3C3C;}\n\t.st5{fill:#554A4C;stroke:#3C3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st6{fill:#69C5DB;stroke:#3C3C3C;stroke-width:2.8346;stroke-miterlimit:10;}\n\t.st7{fill:#B0DDE8;stroke:#3C3C3C;stroke-width:2.8346;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.15
    },
    width: 703,
    height: 702,
    xlinkHref: "DAF5C1A607523A9F.png",
    transform: "matrix(0.24 0 0 0.24 -2.97 -2.59)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 81.4,
    cy: 78.9,
    r: 75.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 123.9,
    cy: 99.9,
    rx: 11.9,
    ry: 13.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 38.8,
    cy: 100.3,
    rx: 11.9,
    ry: 13.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.3,76.1L122.3,76.1c0-20.1-18.5-36.4-41.3-36.4S39.7,55.9,39.7,76.1v17.5h0c0.1,20,18.6,36.2,41.3,36.2 s41.2-16.2,41.3-36.2h0V76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76,107.2c0,0,0.1,3.3,5,3.3c4.9,0,4.8-3.3,4.8-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.3,86c1.4-3,4.9-5.2,9-5.2c3.3,0,6.2,1.4,7.9,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.7,86c-1.4-3-4.9-5.2-9-5.2c-3.3,0-6.2,1.4-7.9,3.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 68.5,
    cy: 93.2,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 93.4,
    cy: 93.2,
    r: 3.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.1,73.9c0,0,2.8,5.2,10.3,4.5c7.5-0.8,15.1-8.9,15.1-8.9s1.8,4.6,6.8,4.6c4.9,0,6.5-4.6,6.5-4.6 s0.5,4.3,5.5,4.3c5.1,0,7.8-4.3,7.8-4.3s6.6,9.1,14.1,9.1c7.5,0,11.4-6,11.4-6v16.6c4.6-6.1,7.2-13.4,7.2-21.2 c0-22-20.9-39.9-46.8-39.9S34.2,45.8,34.2,67.9c0,8.7,3.3,16.8,8.9,23.4V73.9z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M81.4,122.4c2.9,0,5.6-1,7.7-2.8c2.7-2.2,4.4-5.5,4.4-9.3c0-0.9-0.1-1.8-0.3-2.6c0-0.1,0-0.1,0-0.2 c0,0,0-0.1,0-0.1c-0.7-2.6-3-4.4-5.8-4.4c-1.3,0-2.5,0.4-3.5,1.1c0,0,0,0,0,0c-0.3,0.2-0.6,0.4-0.8,0.7c0,0,0,0,0,0 c-0.5,0.3-1.1,0.7-1.7,0.7h0c-0.6,0-1.2-0.3-1.7-0.7c0,0,0,0,0,0c-0.2-0.3-0.5-0.5-0.8-0.7c0,0,0,0,0,0c-1-0.7-2.2-1.1-3.5-1.1 c-2.8,0-5.1,1.9-5.8,4.4c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c-0.2,0.8-0.3,1.7-0.3,2.6c0,3.7,1.7,7.1,4.4,9.3 C75.7,121.4,78.4,122.4,81.4,122.4L81.4,122.4z M81.4,119c-2.7,0-5-2.1-5.2-4.8c0-0.1,0-0.3,0-0.4c0-2.9,2.3-5.2,5.2-5.2 c2.9,0,5.2,2.3,5.2,5.2c0,0.1,0,0.3,0,0.4C86.3,116.9,84.1,119,81.4,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M86.6,113.8c0,0.1,0,0.3,0,0.4c-0.2,2.7-2.5,4.8-5.2,4.8c-2.7,0-5-2.1-5.2-4.8c0-0.1,0-0.3,0-0.4 c0-2.9,2.3-5.2,5.2-5.2C84.2,108.6,86.6,110.9,86.6,113.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.6,114.2c1.5,1.3,2.4,3.3,2.5,5.4c0,0.1,0,0.2,0,0.3c0,4.3-3.5,7.7-7.7,7.7c-4.3,0-7.7-3.5-7.7-7.7 c0-0.1,0-0.2,0-0.3c0.1-2.1,1-4.1,2.5-5.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon1);
export default __webpack_public_path__ + "static/media/Education-Icon_1.1e37166ec16db70eef0f379b826052bd.svg";
export { ForwardRef as ReactComponent };